window.share_fb = function(url) {
    var facebookUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
    window.open(facebookUrl, 'facebook-share-dialog', "width=626,height=436,noopener");
}

window.share_twitter = function(url) {
    window.open('https://twitter.com/intent/tweet?original_referer='+url,'twitter-share-dialog',"width=626, height=436")
}

window.copy_link  = function(url) {
    navigator.clipboard.writeText(url);
    // Změna textu v elementu vedle tlačítka
    var statusElement = document.getElementById('copy-status');
    statusElement.textContent = 'Zkopírováno';

    // Volitelně: Text po nějakém čase zmizí
    setTimeout(function() {
        statusElement.textContent = '';
    }, 2000); // Text zmizí po 2 vteřinách
}

window.share_whatsapp = function(url) {
    var message = 'Podívejte se na tento odkaz: ' + url;
    var whatsappUrl = 'https://api.whatsapp.com/send?text=' + encodeURIComponent(message);
    window.open(whatsappUrl, '_blank');
}

window.share_email = function(url) {
    var subject = "Podívejte se na tento odkaz";
    var body = "Chtěl(a) bych se s vámi podělit o tento odkaz: " + url;
    var mailtoLink = 'mailto:?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
    
    window.location.href = mailtoLink;
}